import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldWrapper } from '@ngx-formly/core';
export interface Data {
  name: string;
}

@Component({
  selector: 'app-mat-chip',
  template: `<div class="container">
  <div class="row">
      <div class="col-md-3">
      </div>
      <div class="col-md-9 px-0 ">
          <div>
              <mat-chip *ngFor="let chip of chipData" selectable="selectable" [removable]="removable" (removed)="remove(chip)">
                  {{ chip.name }}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
          </div>
  </div>
  </div>
  <div class="row my-3">
      <div class="col-md-3 px-0">
          <label>{{ props.label }} <mat-icon *ngIf="to['tooltip']"
                  matTooltip="{{ to['tooltip'] }}"
                  class="tooltip-icon"
                  matTooltipPosition="right"
                  >help</mat-icon></label>
      </div>
      <div class="col-md-9 px-0 ">
         <mat-chip-grid #chipList>
          <input
              class="form-control"
              placeholder="Type your input and hit enter..."
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="add($event)" 
              [disabled]="getDisable()" 
              [(ngModel)]="newFruit"
          />
      </mat-chip-grid>
        <!-- <mat-chip-list #chipList>
          <input
              class="form-control"
              placeholder="Type your input and hit enter..."
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="add($event)" 
              [disabled]="getDisable()" 
              [(ngModel)]="newFruit"
          />
      </mat-chip-list> -->
  </div>
  </div>
</div>`,
standalone:true,
imports:[
  CommonModule,FormsModule,MatChipsModule,MatTooltipModule]
})
export class MatChipWrapper extends FieldWrapper implements OnInit {
  getDisable(): any {
    return this.field.props?.disabled;
  }
  ngOnInit(): void {
    if (this.field.defaultValue) {
      this.field.defaultValue.keywords.forEach((item: any) => {
        this.chipData.push({ 'name': item });
      })
    }
  }

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  //readonly separatorKeysCodes: number[] = [13, 188]; // ENTER and COMMA
  separatorKeysCodes: number[] = [ENTER, COMMA]; // Configure the separator key codes
  chipData: Data[] = [];
  newFruit: string = '';


  remove(fruit: Data): void {
    const index = this.chipData.indexOf(fruit);

    if (index >= 0) {
      this.chipData.splice(index, 1);
      let keywords: string[] = [];
      this.chipData.forEach(item => {
        keywords.push(item.name);
      })
      this.updateFieldFormControlValue({ keywords: keywords })
    }
  }

  // add(): void {
  //   if (this.newFruit.trim() !== '') {
  //     this.chipData.push({ name: this.newFruit.trim() });
  //     this.newFruit = ''; // Clear the input field
  //   }
  // }

  add(event?: MatChipInputEvent): void {
    // Use the value from the input event if it's provided, otherwise use the bound ngModel
    const value = event ? event.value : this.newFruit;

    // Add our fruit
    if ((value || '').trim()) {
      this.chipData.push({ name: value.trim() }); // you might want to create a new object/instance
      let keywords: string[] = [];
      this.chipData.forEach(item => {
        keywords.push(item.name);
      })
      this.updateFieldFormControlValue({ keywords: keywords })
    }

    // Reset the input value
    if (event) {
      event.input.value = '';
    }

    this.newFruit = '';
  }

  private updateFieldFormControlValue(partialValue: { keywords?: string[] }) {
    // Merge the current value with the updated part
    if (this.field?.formControl) {
      const newValue = {
        ...this.field.formControl.value,
        ...partialValue,
      };
      this.field.formControl.setValue(newValue);
    }
  }
}
